import React, {useEffect, useState} from 'react';
import {connect, useDispatch} from 'react-redux';
import providers from '../../../images/provider_h.png';
import administrators from '../../../images/admin_h.png';
import careHistory from '../../../images/history_h.png';
import benefits from '../../../images/benefits_h.png';
import affiliate from '../../../images/affiliate_h.png';
import plans from '../../../images/plans_h.png';
import {useHistory} from 'react-router-dom';
import actions from '../../../redux/actions';
import './Home.scss';
import {useAuth} from '../../../hooks/useAuth';
import {Redirect} from 'react-router-dom';
import _Modal from '../ModalNewInterface/_Modal';
import Loading from '../../../common/components/Loading/Loading';


/**
 * @description
 * @param { object } props no redux
 * @return { * } component
 */

const providerUserModules = [
    // {
    //     name: 'Historial atenciones',
    //     route: '/attentionsList',
    //     img: careHistory,
    //   },
    // {
    //     name: 'Atenciones',
    //     route: '/newMedicalService',
    //     img: benefits,
    // },
    // {
    //     name: 'Planes',
    //     route: '/plans/list',
    //     img: plans,
    // },
    {
        name: 'Afiliados',
        route: '/v1/affiliates',
        img: affiliate,
    },
];

const providerUserModulesFf = [
    {
        name: 'Historial atenciones',
        route: '/v1/attentionsList',
        img: careHistory,
      },
    {
        name: 'Nueva atenciones',
        route: '/v1/newMedicalService',
        img: benefits,
    },
    {
        name: 'Planes',
        route: '/v1/plans/list',
        img: plans,
    },
    {
        name: 'Afiliados',
        route: '/v1/affiliates',
        img: affiliate,
    },
];

const providerAdminModules = [
    //  {
    //     name: 'Usuarios de Prestadores',
    //     route: '/provider/list',
    //     img: providers,
    //   },
    ...providerUserModules,
];

const providerAdminModulesFf = [
    //  {
    //     name: 'Usuarios de Prestadores',
    //     route: '/provider/list',
    //     img: providers,
    //   },
    ...providerUserModulesFf,
];

const adminModules = [
    {
        name: 'Administradores',
        route: '/v1/admin/list',
        img: administrators,
    },
    {
        name: 'Historial atenciones',
        route: '/v1/attentionsList',
        // route: '/home',
        img: careHistory,
    },
    {
        name: 'Nueva atencion',
        route: '/v1/newMedicalService',
        img: benefits,
    },
    {
        name: 'Usuarios de Prestadores',
        route: '/v1/provider/list',
        img: providers,
    },
    {
        name: 'Afiliados',
        route: '/v1/affiliates',
        img: affiliate,
    },
    {
        name: 'Planes',
        route: '/v1/plans/list',
        img: plans,
    },
];

const Home = ({name, userInfo, switchOfUser, selectSelf, showSidebar, featureFlag}) => {
    const [modules, setModules] = useState([]);
    const history = useHistory();
    const dispatch = useDispatch();

    const {isAdmin} = useAuth();

    useEffect(()=> {
        if (showSidebar && window.innerWidth <= 700) {
            dispatch(actions.common.toggleSideBar());
        }
    }, []);

    useEffect(() => {
        if (userInfo) {
            selectSelf();
        }
        switch (userInfo.role.name) {
            case 'ADMIN':
                setModules(adminModules);
                break;
            case 'PROVIDER_ADMIN':
                if (featureFlag) {
                    setModules(providerAdminModulesFf);
                } else {
                    setModules(providerAdminModules);
                }
                break;
            case 'PROVIDER_USER':
                if (featureFlag) {
                    setModules(providerUserModulesFf);
                } else {
                    setModules(providerUserModules);
                }
                break;
            default:
                setModules(providerUserModules);
                break;
        }
        // eslint-disable-next-line
    }, [name]);

    useEffect(() => {
        switch (userInfo.role.name) {
            case 'ADMIN':
                setModules(adminModules);
                break;
            case 'PROVIDER_ADMIN':
                if (featureFlag) {
                    setModules(providerAdminModulesFf);
                } else {
                    setModules(providerAdminModules);
                }
                break;
            case 'PROVIDER_USER':
                if (featureFlag) {
                    setModules(providerUserModulesFf);
                } else {
                    setModules(providerUserModules);
                }
                break;
            default:
                setModules(providerUserModules);
                break;
        }
        // eslint-disable-next-line
    }, [featureFlag]);


    const pushPage = (name, route) => {
        switchOfUser(name);
        history.push(route);
    };
    const [isModalNewInterfaceOpen, setModalNewInterfaceOpen] = useState(true);
    const [redirectAfterModal, setRedirectAfterModal] = useState(false);

    const closeModal = () => {
        setModalNewInterfaceOpen(false);
        setRedirectAfterModal(true);
    };
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (loading) {
            setTimeout(() => {
                setLoading(false);
            }, 2000);
        }
    }, [featureFlag]);

    return (
        // <div className={showSidebar && window.innerWidth <= 700 ? 'ul-div-background bg-mt-10' : 'ul-div-background'}>
        //     <p className="ul-p-name">{name}</p>
        //     <div className="ul-div-section">
        //         {
        //             isAdmin ?
        //                 <div> className="btn-section-admin">
        //                     {
        //                         modules && modules.map(({name, route, img}, i) => (
        //                             <button
        //                                 key={i}
        //                                 className={`feature${i} btn-bpb`}
        //                                 onClick={() => pushPage(name, route)}>
        //                                 <img src={img} alt={name}/>
        //                             </button>
        //                         ))
        //                     }
        //                 </div> :
        //                 <div className={modules.length > 1 ? 'btn-section-pu' : 'btn-section-pu-center'}>
        //                     {
        //                         modules && modules.map(({name, route, img}, i) => (
        //                             <button
        //                                 key={i}
        //                                 className='btn-bpb'
        //                                 onClick={() => pushPage(name, route)}>
        //                                 <img src={img} alt={name}/>
        //                             </button>
        //                         ))
        //                     }
        //                 </div>
        //         }
        //     </div>
        // </div>
        <>
            {(featureFlag || userInfo.role.name === 'ADMIN') && <_Modal isOpen={isModalNewInterfaceOpen} onClose={closeModal} />}
            {!isModalNewInterfaceOpen && redirectAfterModal && modules[0]?.route && (
                <Redirect to={modules[0].route} />
            )}
            <div style={{marginLeft: '550px'}}>
                {loading && <Loading />}
                {!loading && (
                    <>
                        {featureFlag && <_Modal isOpen={isModalNewInterfaceOpen} onClose={closeModal} />}
                        {!isModalNewInterfaceOpen && redirectAfterModal && modules.length > 0 && modules[0]?.route && (
                            <Redirect to={modules[0].route} />
                        )}
                    </>
                )}
            </div>
        </>

    );
};

const mapStateToProps = (state) => ({
    name: localStorage.getItem('name'),
    userInfo: state.login.userInfo,
    showSidebar: state.common.showSidebar,
    featureFlag: state.home.setSelfState.featureFlag,
});

const mapDispatchToProps = (dispatch) => ({
    switchOfUser: (name) => dispatch(actions.home.switchOfUser(name)),
    selectSelf: () => dispatch(actions.home.selectSelf()),
});

Home.propTypes = {};


export default connect(mapStateToProps, mapDispatchToProps)(Home);
